import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionButtons = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'new_batch_test',
      label: 'New Batch Test',
      description: 'Initiate batch testing workflow',
      icon: 'FlaskConical',
      path: '/batch-testing-records',
      color: 'bg-primary',
      hoverColor: 'hover:bg-primary/90'
    },
    {
      id: 'adverse_event',
      label: 'Report Adverse Event',
      description: 'Create new adverse event report',
      icon: 'Shield',
      path: '/adverse-event-reporting',
      color: 'bg-warning',
      hoverColor: 'hover:bg-warning/90'
    },
    {
      id: 'equipment_check',
      label: 'Equipment Check',
      description: 'Schedule equipment calibration',
      icon: 'Settings',
      path: '/laboratory-equipment',
      color: 'bg-secondary',
      hoverColor: 'hover:bg-secondary/90'
    },
    {
      id: 'compliance_review',
      label: 'Compliance Review',
      description: 'Start regulatory compliance review',
      icon: 'CheckCircle',
      path: '/regulatory-compliance',
      color: 'bg-success',
      hoverColor: 'hover:bg-success/90'
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
        <p className="text-sm text-muted-foreground">Frequently used workflow shortcuts</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => handleActionClick(action?.path)}
            className={`p-4 rounded-lg text-white transition-all duration-150 hover:scale-105 hover:shadow-md ${action?.color} ${action?.hoverColor} group`}
          >
            <div className="flex flex-col items-center space-y-3">
              <div className="p-3 bg-white/20 rounded-full group-hover:bg-white/30 transition-colors duration-150">
                <Icon name={action?.icon} size={24} color="white" />
              </div>
              <div className="text-center">
                <h4 className="font-medium text-sm">{action?.label}</h4>
                <p className="text-xs opacity-90 mt-1">{action?.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <p className="text-xs text-muted-foreground">
            Need help? Check our workflow guides
          </p>
          <Button variant="ghost" size="sm">
            <Icon name="HelpCircle" size={16} className="mr-2" />
            Help Center
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionButtons;